//足球 杯赛 WCQ Asian Zone|世界杯亚洲区预选赛 full
import PlatfromFootballFIFAWCQAZFull from '@containers/platfrom_football/FIFAWorldCupFull_WCQAZ'

export default {
  PlatfromFootballFIFAWCQAZFull,
}
